import { NumericHelpers } from "@core/helpers";

export const ISalary = Object.freeze({
  amount: "amount",
  range: "range",
  periodicity: "salary_type",
  fluctuating: "fluctuating",
});

export class SalaryModel {
  constructor(data = {}) {
    this[ISalary.amount] = data[ISalary.amount];
    this[ISalary.range] = data[ISalary.range];
    this[ISalary.periodicity] = data[ISalary.periodicity];
    this[ISalary.fluctuating] = data[ISalary.fluctuating];
  }

  getAmount() {
    return this[ISalary.amount];
  }

  getAmountFormatted() {
    return NumericHelpers.formatNumberAsCurrency({ number: this.getAmount() });
  }

  getRange() {
    return this[ISalary.range] || null;
  }

  getRangeFormatted() {
    if (this.getRange()) {
      const { min, max } = this.getRange();
      return {
        min: NumericHelpers.formatNumberAsCurrency({ number: min }),
        max: NumericHelpers.formatNumberAsCurrency({ number: max }),
      };
    }
    return { min: "- €", max: "- €" };
  }

  getPeriodicity() {
    return this[ISalary.periodicity];
  }

  isFluctuating() {
    return this[ISalary.fluctuating] === true;
  }

  isValid() {
    return (
      this[ISalary.fluctuating] || //
      (this[ISalary.amount] !== undefined && this[ISalary.periodicity] !== undefined) ||
      this[ISalary.range] !== undefined
    );
  }

  isRangeValid() {
    return (
      this[ISalary.range]?.min >= 0 &&
      this[ISalary.range].min !== null && //
      this[ISalary.range]?.max > 0 &&
      this[ISalary.range].max !== null &&
      this[ISalary.range].max > this[ISalary.range].min
    );
  }
}
